/* Visibility Mesh header menu: opens and closes the desktop panels and the mobile drawer.
   Toggles carry aria-expanded. Escape closes, a click outside closes, and focus leaving a panel closes it. */
(function () {
  'use strict';
  var nav = document.querySelector('[data-vm-nav]');
  var GUTTER = 16;

  function place(item) {
    var panel = item.querySelector('.vm-panel');
    var toggle = item.querySelector('.vm-nav__toggle');
    if (!panel || !toggle) return;
    panel.style.left = '0px';
    panel.style.top = '0px';
    var origin = panel.getBoundingClientRect();
    var row = toggle.closest('.header__row') || toggle.closest('header') || toggle;
    var bottom = row.getBoundingClientRect().bottom;
    var width = panel.offsetWidth;
    var want = toggle.getBoundingClientRect().left;
    var left = Math.max(GUTTER, Math.min(want, window.innerWidth - width - GUTTER));
    panel.style.left = Math.round(left - origin.left) + 'px';
    panel.style.top = Math.round(bottom + 8 - origin.top) + 'px';
  }

  function closeItem(item, returnFocus) {
    var toggle = item.querySelector('.vm-nav__toggle');
    var panel = item.querySelector('.vm-panel');
    if (!toggle || !panel || panel.hidden) return;
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (returnFocus) toggle.focus();
  }

  function closeAll(except) {
    if (!nav) return;
    nav.querySelectorAll('.vm-nav__item').forEach(function (item) { if (item !== except) closeItem(item, false); });
  }

  function openItem(item) {
    closeAll(item);
    var toggle = item.querySelector('.vm-nav__toggle');
    var panel = item.querySelector('.vm-panel');
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    place(item);
  }

  if (nav) {
    nav.querySelectorAll('.vm-nav__item').forEach(function (item) {
      var toggle = item.querySelector('.vm-nav__toggle');
      var panel = item.querySelector('.vm-panel');
      toggle.addEventListener('click', function () {
        if (panel.hidden) openItem(item); else closeItem(item, false);
      });
      item.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !item.contains(e.relatedTarget)) closeItem(item, false);
      });
    });
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      nav.querySelectorAll('.vm-nav__item').forEach(function (item) {
        var panel = item.querySelector('.vm-panel');
        if (panel && !panel.hidden) closeItem(item, item.contains(document.activeElement));
      });
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth < 1320) { closeAll(null); return; }
      nav.querySelectorAll('.vm-nav__item').forEach(function (item) {
        var panel = item.querySelector('.vm-panel');
        if (panel && !panel.hidden) place(item);
      });
    });
  }

  /* Mobile drawer */
  var drawer = document.getElementById('vm-drawer');
  var openBtn = document.querySelector('[data-vm-drawer-open]');
  if (drawer && openBtn) {
    var closeBtn = drawer.querySelector('[data-vm-drawer-close]');
    openBtn.addEventListener('click', function () {
      if (typeof drawer.showModal === 'function') drawer.showModal(); else drawer.setAttribute('open', '');
      openBtn.setAttribute('aria-expanded', 'true');
    });
    function shut() { if (drawer.open) drawer.close(); }
    if (closeBtn) closeBtn.addEventListener('click', shut);
    drawer.addEventListener('close', function () { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) shut(); });
    drawer.querySelectorAll('.vm-drawer__toggle').forEach(function (btn) {
      var region = document.getElementById(btn.getAttribute('aria-controls'));
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        region.hidden = open;
      });
    });
    window.addEventListener('resize', function () { if (window.innerWidth >= 1320) shut(); });
  }
})();
